export default "__VITE_ASSET__DYWdgkwG__"